import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const TutorCreate_UpdateSlice = createSlice({
  name: "TutorCreate_UpdateSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    TutorCreate_Update: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successTutorCreate_Update: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTutorCreate_Update: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTutorCreate_Update: (state) => {
      state.data = {};
    },
  },
});

export const {
  TutorCreate_Update,
  failureTutorCreate_Update,
  successTutorCreate_Update,
  clearTutorCreate_Update,
} = TutorCreate_UpdateSlice.actions;

export default TutorCreate_UpdateSlice.reducer;
